module.exports = __webpack_public_path__ + "static/media/pago-seguro.97a4a53f.png";